import { Controller } from "@hotwired/stimulus";
import Chart from "chart.js"

export default class extends Controller {

  connect() {
    console.log("Chart materias controller connected");
    this.createChart()
  }

  createChart() {
    const ctx = this.element.getContext("2d")

    const data = {
      labels: JSON.parse(this.data.get('labels')),
      datasets: [
        {
          data: JSON.parse(this.data.get('data')),
        }
      ]
    }

    const options = {
      legend: {
        display: false
      },
      scales: {
        yAxes: [{
          ticks: {
            beginAtZero: true
          }
        }]
      }
    }

    var myLineChart = new Chart(ctx, {
        type: 'line',
        data: data,
        options: options
    });
  }

}
